import Slider from '../../../javascripts/globals/slider';

class BasicSlider extends Slider {
  constructor($slider, mq, config) {
    super($slider, mq, config);

    this.$slider = $slider;

    this.initControls();
    super.initEvents();
  }
}

export default BasicSlider;
